import { api_host,api_auth} from '../../common/globals/constants';

export const getMonitorsList = (objective, begin, final, token) => 
fetch(api_host+`/reporte/general/objetivos/${objective}/monitores/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}`)
.then(response => response.json())